module.exports = __webpack_public_path__ + "static/media/image_d.ebf84bfb.png";